document.addEventListener('DOMContentLoaded', function () {
	const modalDialog = document.getElementById('modalDialog');
	const closeButton = document.getElementById('closeButton');
	const productPopup = document.getElementsByClassName('productPopup');
	//モーダルを開く
	//modalDialog.showModal();
	//スクロール不可
	//document.documentElement.style.overflow = "hidden";

	// モーダルを閉じる
	closeButton?.addEventListener('click', () => {
		modalDialog.close();
		// モーダルを解除すると、スクロール可能になる
		document.documentElement.removeAttribute("style");
	});

	productPopup[0].addEventListener('click', (e) => {
		//console.log("PRESS:" + e.target.nodeName);
		if (e.target.nodeName == "DIALOG") {
			modalDialog.close();
			// モーダルを解除すると、スクロール可能になる
			document.documentElement.removeAttribute("style");
		}
	});


	/* COOKIE */
	let cook;       //cookieデータを格納する変数
	let START, END;  //訪問回数部分を切取る為の位置を格納
	let cnt = 0;        //訪問回数を格納

	cook = document.cookie + ";"; //変数cookにcookieデータを入れる
	START = cook.indexOf("view_counts=", 0); 	//変数STARTにカウントデータの最初の位置を入れる
	//データの有無で分岐
	if (START === -1) {
		document.cookie = "view_counts=1;"; //cookieに訪問回数=1を書き込む
		//モーダルを開く
		modalDialog.showModal();
		//スクロール不可
		document.documentElement.style.overflow = "hidden";

	} else {
		END = cook.indexOf(";", START); //カウントデータの最後の部分「;」の位置を取得
		cnt = cook.substring(START + 12, END); //数値の部分だけを切り取る
		//数値に変換できない例外が出た時の処理
		try {
			cnt = parseInt(cnt) + 1; //取得した回数に+1して表示する
			//alert(cnt + "回目の訪問です!！");
			document.cookie = "view_counts=" + cnt + ";"; //cookieに訪問回数を書き込む
		} catch (e) {
			//alert("訪問回数の取得に失敗しました。");
		}
	}



});
